import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

const AaliFilmz = () => {
  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => { if (entry.isIntersecting) entry.target.classList.add('visible'); });
    }, { threshold: 0.2 });
    document.querySelectorAll('.scroll-reveal, .service-item, .info-card').forEach(el => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <>
      <div className="company-hero" style={{ background: 'linear-gradient(135deg, #0e7490, #06b6d4)' }}>
        <div className="hero-content">
          <h1>AALI FILMZ</h1>
          <p>Digital content studio specializing in web series, short films, and digital entertainment</p>
        </div>
      </div>
      <div className="company-content">
        <div className="container">
          <div className="company-grid">
            <div className="left scroll-reveal">
              <h2>About AALI FILMZ</h2>
              <p>AALI FILMZ creates engaging digital content for the modern audience. Our focus on innovative storytelling and platform-specific content has made us a leader in the digital entertainment space.</p>
              <h3>Our Services</h3>
              <div className="services-list">
                <div className="service-item"><span>✔</span> Web Series Production</div>
                <div className="service-item"><span>✔</span> Short Films</div>
                <div className="service-item"><span>✔</span> Digital Content Creation</div>
                <div className="service-item"><span>✔</span> Streaming Platform Content</div>
                <div className="service-item"><span>✔</span> Brand Collaborations</div>
              </div>
            </div>
            <div className="info-card scroll-reveal">
              <h4>Company Info</h4>
              <div className="info-block">
                <span className="info-label">Industry</span>
                <strong className="info-value">Media & Entertainment</strong>
              </div>
              <div className="info-block">
                <span className="info-label">Parent Company</span>
                <strong className="info-value">AALI GROUP</strong>
              </div>
              <div className="actions">
                <Link to="/contact" className="btn-primary">Get in Touch</Link>
                <Link to="/coming-soon" className="btn-primary">Visit Main Website</Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AaliFilmz;